<template>
  <div class="content has-text-centered">
    <table
      class="table is-striped is-responsive"
      :class="{ 'direction-rtl': Language == 'fa' || Language == 'ar' }"
      id="paymentHistoryTable"
    >
      <thead>
        <tr>
          <th>{{ $t('id') }}</th>
          <th>{{ $t('date').tUpper() }}</th>
          <th>{{ $t('account').tUpper() }}</th>
          <th>{{ $t('type').tUpper() }}</th>
          <th>{{ $t('gateway') }}</th>
          <th>{{ $t('currency').tUpper() }}</th>
          <th>{{ $t('amount').tUpper() }}</th>
          <th>{{ $t('status').tUpper() }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(payment, i) in paymentHistory"
          :key="'payments-' + i"
        >
          <td class="has-text-weight-bold">#{{ payment.id }}</td>
          <td>{{ $formatDateTime(payment.date) }}</td>
          <td>{{ printWallet(payment.trading_account) }}</td>
          <td>
            <span v-if="payment.type.indexOf('transfer') !== -1">
              <span class="subtitle is-size-7">#{{ payment.id }} -</span>
              <span v-if="payment.type.indexOf('withdrawal') !== -1">{{ $t('transfer_out') }}</span>
              <span v-if="payment.type.indexOf('deposit') !== -1">{{ $t('transfer_in') }}</span>
            </span>
            <span v-else>{{ payment.type }}</span>
          </td>
          <td>{{ payment.gateway || '-' }}</td>
          <td>{{ chooseDisplayCurrency(payment) }}</td>
          <td :class="getValueColor(payment.type)">{{ chooseDisplayValue(payment) }}</td>
          <td>
            <span v-if="payment.status === 'processed'">
              <span class="icon has-text-success">
                <i class="fa fa-check"></i>
              </span>
            </span>
            <span v-if="payment.status === 'cancelled'">
              <span class="icon">
                <i class="fa fa-times"></i>
              </span>
            </span>
            <span v-if="payment.status === 'pending'">
              <span class="icon">
                <i class="fa fa-clock-o"></i>
              </span>
            </span>
            {{ payment.status }}
          </td>
        </tr>
      </tbody>
    </table>
    <pagination
      for="payment-history"
      :records="pagination.total"
      :per-page="pagination.maxItemsPerPage"
      :chunk="4"
      :count-text="pagination.total + ' ' + $t('records')"
    ></pagination>
  </div>
</template>

<script>
import { Pagination, PaginationEvent } from 'vue-pagination-2-bulma'
import { service } from '../../app'
import { mapGetters } from 'vuex'
import config from '../../config'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      paymentHistory: null,
      currencySymbols: config.currencies,
      pagination: {
        page: 1,
        total: 1,
        maxItemsPerPage: 10,
      },
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {
    PaginationEvent.$on('vue-pagination::payment-history', page => {
      this.pagination.page = page
      this.getPaymentHistory()
    })
    this.getPaymentHistory()
  },
  methods: {
    getPaymentHistory() {
      service
        .post('/finance/payment-history/user', {
          userID: this.User.info.ID,
          page: this.pagination.page,
          'include-external': true,
        })
        .then(response => {
          this.paymentHistory = response.data.payments
          this.pagination.total = response.data.count
        })
    },
    chooseDisplayValue(payment) {
      if (payment.value == 0 || ((parseFloat(payment.value) + parseFloat(payment.fee)).toFixed(2) == 10.01 && parseFloat(payment.value_requested) == 10)) {
        return this.$formatMoney(payment.value_requested, this.currencySymbols[payment.currency])
      } else if (payment.gateway && payment.gateway.indexOf('Crypto') !== -1 && payment.type && payment.type.indexOf('withdrawal') !== -1) {
        let paymentCurrency = payment.currency
        if (this.User && this.User.wallet && this.User.wallet.currency) {
          paymentCurrency = this.User.wallet.currency
        }
        return this.$formatMoney(payment.value_requested, this.currencySymbols[paymentCurrency])
      } else {
        return this.$formatMoney(parseFloat(payment.value), this.currencySymbols[payment.currency])
      }
    },
    chooseDisplayCurrency(payment) {
      if (payment.gateway && payment.gateway.indexOf('Crypto') !== -1 && payment.type && payment.type.indexOf('withdrawal') !== -1 && this.User && this.User.wallet && this.User.wallet.currency) {
        return this.User.wallet.currency
      } else {
        return payment.currency
      }
    },
    getValueColor(paymentType) {
      if (paymentType.indexOf('deposit') !== -1) {
        return 'text-green'
      } else {
        return 'text-red'
      }
    },
    printWallet(ta) {
      if (ta === '-1') {
        return 'wallet'
      } else {
        return ta
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';

#paymentHistoryTable {
  margin-top: 20px;
}

.text-red {
  color: $red;
}

.text-green {
  color: $green;
}
</style>



// WEBPACK FOOTER //
// payment-history.vue?113ce1b0